import React from "react";
import { SectionTop, SectionCards } from "../../../../components";
import { exploreSectionData } from "../../../../assets/data/homeData";

export default function ExploreSection() {
	return (
		<section className="no-px-md">
			<SectionTop
				heading="Explore all ways you can be with us"
				description={
					<>
						Connect with us to make the world a better place
						<span>
							"And if a house be divided against itself, that
							house cannot stand".
						</span>
					</>
				}
				stretchHeading
			/>

			<SectionCards data={exploreSectionData} />
		</section>
	);
}
